let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4DKjv")).then(() => parcelRequire('lqPYT'));